/**
 * Party Records
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LegalCasesState = {
  partyTag: {
    showDialog: false,
  },
}

export const LegalCasesActions = {
  fetchPartyLegalCases: async (_, requestData) => {
    return axiosRequest.
      get(`/parties/${requestData.id}/legal_cases`, { params: requestData.params }).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },

  fetchLegalCaseParties: async (_, requestData) => {
    return axiosRequest.
      get(`/legal_cases/${requestData.id}/parties`, { params: requestData.params }).
      then(({ data }) => data).
      catch(handleError)
  },

}

export const LegalCasesMutations = {
  setShowTagPartyDialog: (state, payload) => {
    state.partyTag.showDialog = payload
  },
}

export const LegalCasesGetters = {}
